import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

export const getMayorSettings = async () => {
  try {
    const response = await axiosInstance.get('/MayorSettings/GetMayorSettings');
    return response.data;
  } catch (error) {
    console.error('Error fetching mayor settings:', error);
    throw error;
  }
};
